import {Component, Injector, OnInit} from'@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AuthenticateModel, TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';
import { QrMenaAuthService } from 'QrMena/services/qrmena-auth.service';
 
@Component({
    selector:'qrmena-home',
    templateUrl:'./cashier-home.component.html'
})
export class QRmenaCashierHomeComponent extends AppComponentBase implements OnInit{

    tenantId:number
    pincode:string
    storId:string
    tableId:string
    constructor(private _router:Router,private routerNavigate:ActivatedRoute,public loginService: QrMenaAuthService,injector: Injector){
        super(injector);
    } 
    ngOnInit(): void
     {
        //   this.tenantId = (Number(this.routerNavigate.snapshot.queryParams['tenantId']));
        //   this.pincode = this.routerNavigate.snapshot.queryParams['pincode'];
        //   this.storId = this.routerNavigate.snapshot.queryParams['storeid'];
        //   this.tableId = this.routerNavigate.snapshot.queryParams['tableId'];

            let parmaters=this.routerNavigate.snapshot.queryParams['data']
           let result:any= JSON.parse(atob(parmaters));
            this.tenantId=result.tenantId
            this.storId=result.storied
            this.tableId=result.tableId
            this.pincode=result.pincode

          console.log(this.tenantId,this.pincode,this.storId, this.routerNavigate.snapshot
          )
          abp.multiTenancy.setTenantIdCookie(this.tenantId)
                abp.utils.setCookieValue(
                    AppConsts.appSessionItems.storeId,
                    this.storId,
                    new Date(new Date().getTime() + 365 * 86400000), // 1 year
                    abp.appPath
                );
                
                abp.utils.setCookieValue(
                    AppConsts.appSessionItems.pinCode,
                    this.pincode,
                    new Date(new Date().getTime() + 365 * 86400000), // 1 year
                    abp.appPath
                );
                 abp.utils.setCookieValue(
                    AppConsts.appSessionItems.tableId,
                    this.tableId,
                    new Date(new Date().getTime() + 365 * 86400000), // 1 year
                    abp.appPath
                );
                 this.loginService.authenticateModel.pinCode=this.pincode
               
                this.loginService.authenticateUsingPincode(()=>{
                    this.setTenantName()
                })
    }
    handelNavigate(){
        
          this._router.navigate(['/QRMENA/ITEMS-PAGE']);
    }
}


// WEBPACK FOOTER //
// ./src/QrMena/cashier/cashier-home-component/cashier-home.component.ts